import {MouseEventHandler, useCallback} from 'react';
import {Field} from '../../types/Field';
import {Schema} from '../../types/Schema';
import {ResourceDetails} from '../../types/ResourceDetails';
import {Actions} from '../../types/Action';
import {doNothing, useActionAndArgs} from './useActionAndArgs';
import {OnClickFn} from '../../common/ActionText';

export type OnPressAction = MouseEventHandler<HTMLElement>;

export function useOnPressAction(
  field: Field,
  schema: Schema,
  item: ResourceDetails,
  actions: Actions,
): OnPressAction | undefined {
  const {action, args} = useActionAndArgs(
    field,
    schema,
    item,
    actions,
    'on_press',
    '',
  );

  const onPress = useCallback<OnClickFn>(
    (evt) => {
      evt.stopPropagation();
      evt.preventDefault();
      action(args);
    },
    [action, args],
  );

  if (action === doNothing) {
    return;
  }

  return onPress;
}
